'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _input = require('../input');

var _input2 = _interopRequireDefault(_input);

var _button = require('../button');

var _button2 = _interopRequireDefault(_button);

var _categoryIconButton = require('../categoryIconButton');

var _categoryIconButton2 = _interopRequireDefault(_categoryIconButton);

var _simpleModal = require('../simpleModal');

var _simpleModal2 = _interopRequireDefault(_simpleModal);

var _sectionTitle = require('../sectionTitle');

var _sectionTitle2 = _interopRequireDefault(_sectionTitle);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // THIS IS NOT A REUSABLE COMPONENT
// This is just a demonstration..


var styles = {
  row: {
    marginBottom: '25px'
  },
  flexRow: {
    display: 'flex',
    '@media (max-width: 767px)': {
      display: 'block',
      marginBottom: 0
    }
  },
  inputWrapper: {
    flexGrow: 1,
    '@media (max-width: 767px)': {
      display: 'block',
      marginBottom: '25px'
    }
  },
  inputTwoColumns: {
    flexBasis: 'calc(50% - 15px)',
    '@media (max-width: 767px)': {
      flexBasis: 'auto'
    }
  },
  categoryIconButton: {
    margin: '0 0 15px',
    width: "calc(25% - 15px)",
    '@media (max-width: 767px)': {
      width: "calc(50% - 5px)"
    }
  },
  iconsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    flexFlow: 'row wrap'
  },
  iconsMessage: {
    fontFamily: 'Helvetica Neue',
    fontSize: '16px',
    color: '#4a494b',
    textAlign: 'center',
    margin: '15px 0 30px'
  },
  modalWrapper: {
    padding: '50px',
    '@media (max-width: 767px)': {
      padding: '0 30px'
    }
  },
  modalText: {
    color: '#4a494b',
    textAlign: 'center',
    fontFamily: 'Helvetica Neue',
    fontSize: '18px',
    lineHeight: '24px',
    '@media (max-width: 767px)': {
      fontSize: '16px'
    }
  },
  sectionTitleWrapper: {
    fontSize: '30px',
    '@media (max-width: 767px)': {
      fontSize: '26px'
    }
  }
};

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form(props) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

    _this.state = {
      submitted: false,
      data: {
        firstName: '',
        lastName: '',
        companyName: '',
        email: '',
        phoneNumber: '',
        companyWebsite: '',
        generalDescription: '',
        selectedCategories: {}
      },
      required: {
        firstName: true,
        lastName: true,
        companyName: true,
        email: true,
        phoneNumber: true,
        companyWebsite: true
      },
      errors: {},
      categoryError: false,
      categories: [{
        url: 'accessories',
        name: 'accessories'
      }, {
        url: 'adult',
        name: 'adult'
      }, {
        url: 'apparel',
        name: 'apparel'
      }, {
        url: 'av',
        name: 'audio & visual'
      }, {
        url: 'auto',
        name: 'auto'
      }, {
        url: 'deviceaccessories',
        name: 'device accessories'
      }, {
        url: 'edc',
        name: 'everyday carry'
      }, {
        url: 'furniture',
        name: 'furniture'
      }, {
        url: 'grooming',
        name: 'grooming'
      }, {
        url: 'homedecor',
        name: 'home decor'
      }, {
        url: 'kitchen',
        name: 'kitchen'
      }, {
        url: 'outdoor',
        name: 'outdoor'
      }, {
        url: 'pets',
        name: 'pets'
      }, {
        url: 'shoe',
        name: 'shoes'
      }, {
        url: 'watch',
        name: 'watches'
      }, {
        url: 'other',
        name: 'other'
      }]
    };
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleSelectCategory = _this.handleSelectCategory.bind(_this);
    return _this;
  }

  _createClass(Form, [{
    key: 'dimension',
    value: function dimension() {
      return {
        width: this.props.width || 'auto',
        height: this.props.height || 'auto',
        maxWidth: this.props.maxWidth || 'auto',
        padding: this.props.padding || '20px'
      };
    }
  }, {
    key: 'validate',
    value: function validate(fields) {
      var _this2 = this;

      var errors = this.state.errors;
      Object.keys(fields).forEach(function (field) {
        if (_this2.state.required[field] && _this2.state.data[field] === '') {
          errors[field] = true;
        } else {
          delete errors[field];
        }
      });
      this.setState({
        errors: errors
      });

      if (Object.keys(errors).length === 0) {
        return true;
      }
    }
  }, {
    key: 'validateEmail',
    value: function validateEmail(email) {
      var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var errors = this.state.errors;

      if (!regex.test(email.toLowerCase())) {
        errors.email = true;
        this.setState({
          errors: errors
        });
        return false;
      }

      delete errors.email;
      this.setState({
        errors: errors
      });
      return true;
    }
  }, {
    key: 'validatePhoneNumber',
    value: function validatePhoneNumber(phoneNumber) {
      var regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
      var errors = this.state.errors;

      if (!regex.test(phoneNumber.toLowerCase())) {
        errors.phoneNumber = true;
        this.setState({
          errors: errors
        });
        return false;
      }

      delete errors.phoneNumber;
      this.setState({
        errors: errors
      });
      return true;
    }
  }, {
    key: 'validateCompanyWebsite',
    value: function validateCompanyWebsite(companyWebsite) {
      var regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/im;
      var errors = this.state.errors;

      if (!regex.test(companyWebsite)) {
        errors.companyWebsite = true;
        this.setState({
          errors: errors
        });
        return false;
      }

      delete errors.companyWebsite;
      this.setState({
        errors: errors
      });
      return true;
    }
  }, {
    key: 'validateCategory',
    value: function validateCategory() {
      if (Object.keys(this.state.data.selectedCategories).length === 0) {
        this.setState({
          categoryError: true
        });
        return false;
      }

      this.setState({
        categoryError: false
      });
      return true;
    }
  }, {
    key: 'handleInputChange',
    value: function handleInputChange(e) {
      var _this3 = this;

      var context = this;
      var field = e.target.dataset.fieldName;
      var data = this.state.data;
      data[field] = e.target.value;
      this.setState({
        data: data
      }, function () {
        context.validate(_defineProperty({}, field, true));

        if (field === 'email') {
          context.validateEmail(_this3.state.data.email);
        } else if (field === 'phoneNumber') {
          context.validatePhoneNumber(_this3.state.data.phoneNumber);
        } else if (field === 'companyWebsite') {
          context.validateCompanyWebsite(_this3.state.data.companyWebsite);
        }
      });
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      var _this4 = this;

      var requiredFieldsValidated = this.validate(this.state.required);
      var categorySelected = this.validateCategory();
      var emailValidated = this.validateEmail(this.state.data.email);
      var phoneValidated = this.validatePhoneNumber(this.state.data.phoneNumber);
      var companyWebsiteValidated = this.validateCompanyWebsite(this.state.data.companyWebsite);

      if (requiredFieldsValidated && categorySelected && emailValidated && phoneValidated && companyWebsiteValidated) {
        if ($) {
          $.ajax({
            type: 'POST',
            url: '/submit_partner_request',
            data: this.state.data
          }).done(function (response) {
            console.log("success");

            _gaq.push(['_trackEvent', 'Extra', 'Partner Request Submitted']);

            _this4.setState({
              submitted: true
            }, function () {
              _simpleModal2["default"].show();

              partnerScrollButton.hideElement();
            });
          }).fail(function (err) {
            console.log('failed to send the form data:', err);
          });
        }

        this.setState({
          data: {
            firstName: '',
            lastName: '',
            companyName: '',
            email: '',
            phoneNumber: '',
            companyWebsite: '',
            generalDescription: '',
            selectedCategories: {}
          },
          errors: {}
        });
      }
    }
  }, {
    key: 'handleSelectCategory',
    value: function handleSelectCategory(selected, category) {
      var _this5 = this;

      var data = this.state.data;
      var selectedCategories = this.state.data.selectedCategories;

      if (selected) {
        selectedCategories[category] = true;
      } else {
        delete selectedCategories[category];
      }

      data[selectedCategories] = selectedCategories;
      this.setState({
        data: data
      }, function () {
        _this5.validateCategory();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var errorMessage = Object.keys(this.state.errors).length > 0 ? "Please complete all required fields" : null;
      var emailErrorMessage = this.state.errors.email ? "Please enter the correct email address" : null;
      var errorStyle = {
        fontFamily: 'Helvetica Neue',
        fontSize: '16px',
        lineHeight: '25px',
        fontWeight: 700,
        color: '#f3494b',
        textAlign: 'center',
        marginBottom: '15px'
      };
      var noErrorStyle = {
        marginBottom: '15px'
      };
      var errorMessageStyle = errorMessage ? errorStyle : noErrorStyle;
      var categoryErrorStyle = this.state.categoryError ? {
        color: '#f3494b'
      } : {
        color: '#4a494b'
      };

      var modalContent = _react2["default"].createElement('div', {
        style: styles.modalWrapper
      }, _react2["default"].createElement('div', {
        style: styles.sectionTitleWrapper
      }, _react2["default"].createElement(_sectionTitle2["default"].component, {
        title: ["Thank you!", _react2["default"].createElement('br', null), "We will be in touch with you soon."]
      })), _react2["default"].createElement('div', {
        style: styles.modalText
      }, 'One of our buyers will be in touch with you soon, so keep an eye out for our email.'));

      var modal = _react2["default"].createElement(_simpleModal2["default"].component, null, modalContent);

      var defaultPage = _react2["default"].createElement('form', {
        style: this.dimension(),
        'aria-label': "Partner with Us"
      }, _react2["default"].createElement(_radium.StyleRoot, null, _react2["default"].createElement('div', {
        style: styles.sectionTitleWrapper,
        role: 'heading',
        'aria-level': '1'
      }, _react2["default"].createElement(_sectionTitle2["default"].component, {
        wrapperCustomStyle: {
          marginTop: '50px'
        },
        title: 'Let\'s do this'
      }))), _react2["default"].createElement('div', null, _react2["default"].createElement('div', {
        style: [styles.flexRow, styles.row]
      }, _react2["default"].createElement(_input2["default"].component, {
        wrapperStyle: styles.inputWrapper,
        name: 'First Name',
        error: this.state.errors.firstName,
        width: '100%',
        onBlur: this.handleInputChange,
        onChange: this.handleInputChange,
        className: 'firstName',
        fieldName: 'firstName',
        value: this.state.data.firstName,
        required: true
      }), _react2["default"].createElement('div', {
        style: {
          width: '30px'
        }
      }), _react2["default"].createElement(_input2["default"].component, {
        wrapperStyle: styles.inputWrapper,
        name: 'Last Name',
        error: this.state.errors.lastName,
        width: '100%',
        onBlur: this.handleInputChange,
        onChange: this.handleInputChange,
        className: 'lastName',
        fieldName: 'lastName',
        value: this.state.data.lastName,
        required: true
      })), _react2["default"].createElement('div', {
        style: [styles.flexRow, styles.row]
      }, _react2["default"].createElement(_input2["default"].component, {
        wrapperStyle: [styles.inputWrapper, styles.inputTwoColumns],
        name: 'E-Mail',
        error: this.state.errors.email,
        width: '100%',
        onBlur: this.handleInputChange,
        onChange: this.handleInputChange,
        className: 'email',
        fieldName: 'email',
        value: this.state.data.email,
        required: true
      }), _react2["default"].createElement('div', {
        style: {
          width: '30px'
        }
      }), _react2["default"].createElement(_input2["default"].component, {
        wrapperStyle: [styles.inputWrapper, styles.inputTwoColumns],
        name: 'Phone Number',
        error: this.state.errors.phoneNumber,
        width: '100%',
        onBlur: this.handleInputChange,
        onChange: this.handleInputChange,
        className: 'phoneNumber',
        fieldName: 'phoneNumber',
        value: this.state.data.phoneNumber,
        required: true
      })), _react2["default"].createElement(_input2["default"].component, {
        wrapperStyle: styles.row,
        name: 'Company Name',
        error: this.state.errors.companyName,
        width: '100%',
        onBlur: this.handleInputChange,
        onChange: this.handleInputChange,
        className: 'companyName',
        fieldName: 'companyName',
        value: this.state.data.companyName,
        required: true
      }), _react2["default"].createElement(_input2["default"].component, {
        wrapperStyle: styles.row,
        name: 'Company Website',
        error: this.state.errors.companyWebsite,
        width: '100%',
        onBlur: this.handleInputChange,
        onChange: this.handleInputChange,
        className: 'companyWebsite',
        fieldName: 'companyWebsite',
        value: this.state.data.companyWebsite,
        required: true
      }), _react2["default"].createElement(_input2["default"].component, {
        wrapperStyle: styles.row,
        placeholder: 'Optional',
        name: 'General Description',
        type: 'textarea',
        height: '90px',
        width: '100%',
        onBlur: this.handleInputChange,
        onChange: this.handleInputChange,
        className: 'generalDescription',
        fieldName: 'generalDescription',
        value: this.state.data.generalDescription
      })), _react2["default"].createElement('div', {
        style: [styles.iconsMessage, categoryErrorStyle]
      }, 'Select the categories that best represent your brand.', _react2["default"].createElement('br', null), 'You can choose more than one.'), _react2["default"].createElement('div', {
        style: styles.iconsWrapper
      }, this.state.categories.map(function (category, i) {
        return _react2["default"].createElement(_categoryIconButton2["default"].component, {
          key: i,
          customStyles: styles.categoryIconButton,
          height: '40px',
          fontSize: '10px',
          color: '#999',
          backgroundColor: '#fff',
          borderColor: '#ddd',
          hoverColor: '#4a494b',
          hoverBackgroundColor: '#fff',
          hoverBorderColor: '#4a494b',
          activeColor: '#fff',
          activeBackgroundColor: '#4a494b',
          activeBorderColor: 'transparent',
          category: category.url,
          text: category.name,
          handleSelect: _this6.handleSelectCategory,
          selected: _this6.state.data.selectedCategories[category.name] ? true : false
        });
      })), _react2["default"].createElement('div', {
        style: errorMessageStyle
      }, errorMessage), _react2["default"].createElement(_button2["default"].component, {
        type: 'submit',
        width: '200px',
        height: '40px',
        color: '#fff',
        hoverBackgroundColor: '#0066cc',
        backgroundColor: '#0096ff',
        borderColor: 'transparent',
        onClick: this.handleSubmit
      }, 'submit'));

      return this.state.submitted ? modal : defaultPage;
    }
  }]);

  return Form;
}(_react2["default"].Component);

var component = (0, _radium2["default"])(Form);
exports["default"] = {
  component: component
};